export type CostAnalysisCsvDownloadStatus = 'unstarted' | 'started' | 'succeeded' | 'failed';

export type CostAnalysisCsvDownloadResponseArgs = {
  id: number;
  status: CostAnalysisCsvDownloadStatus;
  status_str: string;
  user_name: string;
  created_at: string;
  finished_at: string | null;
  duration: number | null;
  downloadable: boolean;
  download_urls: { utf8: string; sjis: string } | null;
};

export type CostAnalysisCsvDownloadArgs = {
  id: number;
  status: CostAnalysisCsvDownloadStatus;
  statusStr: string;
  userName: string;
  createdAt: string;
  finishedAt: string | null;
  duration: number | null;
  downloadable: boolean;
  downloadUrls: { utf8: string; sjis: string } | null;
};

export const convertCostAnalysisCsvDownloadResponseToArgs = (
  response: CostAnalysisCsvDownloadResponseArgs
): CostAnalysisCsvDownloadArgs => ({
  id: response.id,
  status: response.status,
  statusStr: response.status_str,
  userName: response.user_name,
  createdAt: response.created_at,
  finishedAt: response.finished_at,
  duration: response.duration,
  downloadable: response.downloadable,
  downloadUrls: response.download_urls
});

export default class CostAnalysisCsvDownload {
  id: number;
  status: CostAnalysisCsvDownloadStatus;
  statusStr: string;
  userName: string;
  createdAt: string;
  finishedAt: string | null;
  duration: number | null;
  downloadable: boolean;
  downloadUrls: { utf8: string; sjis: string } | null;

  constructor(args: CostAnalysisCsvDownloadArgs) {
    this.id = args.id;
    this.status = args.status;
    this.statusStr = args.statusStr;
    this.userName = args.userName;
    this.createdAt = args.createdAt;
    this.finishedAt = args.finishedAt;
    this.duration = args.duration;
    this.downloadable = args.downloadable;
    this.downloadUrls = args.downloadUrls;
  }

  get finished(): boolean {
    return this.status === 'succeeded' || this.status === 'failed';
  }
}
